import { saleProducts } from "../assets/data/saleProducts.js";
import { getSaleProductsReducer, getSaleProductByIdReducer, filterByBrandReducer, filterByCategoryReducer, orderByPriceReducer } from "./saleProductSlice.js";

export const getSaleProducts = () => {
    return (dispatch) => {
        dispatch(getSaleProductsReducer(saleProducts));
    };
};

export const getSaleProductById = (productId) => {
    return (dispatch) => {
        dispatch(getSaleProductByIdReducer(productId))
    };
};

export const filterByBrand = (rooms) => {
    return async (dispatch) => {
        dispatch(filterByBrandReducer(rooms));
    };
};

export const filterByCategory = (type) => {
    return async (dispatch) => {
        dispatch(filterByCategoryReducer(type));
    };
};

export const orderByPrice = (order) => {
    return async (dispatch) => {
        dispatch(orderByPriceReducer(order));
    };
};